import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { Theme } from "@genesis/ui-kit";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

 let persistor = persistStore(store);

ReactDOM.render(
  
    <Theme variant="macys">
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Router>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App/>
          </PersistGate>
        </Provider>
      </Router>
      </LocalizationProvider>
    </Theme>,
  document.getElementById("root")
);

export {persistor};